module.exports = __webpack_public_path__ + "img/11.28a2e3cd.jpg";